<div class="modal-header d-flex justify-content-center position-relative">
  <h4 class="modal-title mx-auto">
    @if (this.mode == "add") {
      Add Appointment
    } @else {
      Edit Appointment
    }
  </h4>

  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss()"
  ></button>
</div>
<div class="modal-body">
  @if (successMessage) {
    <div class="alert alert-success">
      {{ successMessage }}
    </div>
  } @else {
    <form [formGroup]="appointmentForm">
      <div class="mb-3">
        <label for="date" class="form-label">Date</label>
        <input
          id="date"
          type="date"
          class="form-control"
          formControlName="date"
        />
      </div>
      <div class="mb-3">
        <label for="time" class="form-label">Time</label>
        <input
          id="time"
          type="time"
          class="form-control"
          formControlName="time"
        />
      </div>
      <div class="mb-3">
        <label for="location" class="form-label">Location</label>
        <input
          id="location"
          type="text"
          class="form-control"
          formControlName="location"
          placeholder="Add location"
        />
      </div>
      <div class="mb-3">
        <label for="notes" class="form-label">Notes</label>
        <textarea
          id="notes"
          class="form-control"
          formControlName="notes"
          placeholder="Add details"
        ></textarea>
      </div>
    </form>
  }
</div>
<div class="modal-footer">
  @if (!successMessage) {
    <button
      type="button"
      class="btn btn-secondary"
      [disabled]="isSaving"
      (click)="activeModal.dismiss()"
    >
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="appointmentForm.invalid || isSaving"
      (click)="saveAppointment()"
    >
      @if (isSaving) {
        <span
          class="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"
        ></span>
      }
      Save Changes
    </button>
  }
</div>
